
import adTextEmpty from '@/components/common/adTextEmpty.vue'
import AddressPicker from '@/components/common/AddressPicker.vue'
import apiConfig from '@/config/api.config'
import { getCategoryName } from '@/utils/category-dictionary'
import { fetchPublicConfig } from '@/utils/publicConfig'
import { Dialog, Notify } from 'quasar'

export default {
  components: {
    adTextEmpty,
    AddressPicker
  },
  name: 'Cart',
  data () {
    return {
      loading: true,
      // 公共配置（自提地址当前值）：选择自提时展示取货地点
      publicCfg: null,
      cartItems: [],
      selectedItems: [],
      selectedCouponId: null,
      couponList: [],
      showCouponPicker: false,
      showCheckout: false,
      // 履约方式：courier=商家配送（默认） pickup=到店自提
      fulfillmentMode: 'courier',
      fulfillmentModes: [
        { value: 'courier', label: '配送' },
        { value: 'pickup', label: '自提' }
      ],
      submitting: false,
      showSuccess: false,
      showAddressPicker: false,
      selectedAddressId: '',
      selectedAddressLat: null,
      selectedAddressLng: null,
      loadedAddressSnapshot: null, // 加载默认地址时的快照（判断用户是否修改过）
      acceptSubstitute: false,
      contactInfo: {
        name: '',
        phone: '',
        district: '',
        detail: '',
        remark: ''
      },
      // 省份选择（默认广西）
      selectedProvince: '广西壮族自治区',
      // 城市选择（默认贺州）
      selectedCity: '贺州市',
      // 区选择（默认八步区）
      selectedDistrict: '八步区',
      // 区映射表（按城市）
      districtMap: {
        '南宁市': ['兴宁区', '青秀区', '江南区', '西乡塘区', '良庆区', '邕宁区', '武鸣区', '隆安县', '马山县', '上林县', '宾阳县', '横州市'],
        '柳州市': ['城中区', '鱼峰区', '柳南区', '柳北区', '柳江区', '柳城县', '鹿寨县', '融安县', '融水苗族自治县', '三江侗族自治县'],
        '桂林市': ['秀峰区', '叠彩区', '象山区', '七星区', '雁山区', '临桂区', '灵川县', '全州县', '兴安县', '永福县', '灌阳县', '龙胜各族自治县', '资源县', '平乐县', '恭城瑶族自治县', '荔浦市'],
        '梧州市': ['万秀区', '长洲区', '龙圩区', '苍梧县', '藤县', '蒙山县', '岑溪市'],
        '北海市': ['海城区', '银海区', '铁山港区', '合浦县'],
        '防城港市': ['港口区', '防城区', '上思县', '东兴市'],
        '钦州市': ['钦南区', '钦北区', '灵山县', '浦北县'],
        '贵港市': ['港北区', '港南区', '覃塘区', '平南县', '桂平市'],
        '玉林市': ['玉州区', '福绵区', '容县', '陆川县', '博白县', '兴业县', '北流市'],
        '百色市': ['右江区', '田阳区', '田东县', '平果县', '德保县', '靖西市', '那坡县', '凌云县', '乐业县', '田林县', '西林县', '隆林各族自治县'],
        '贺州市': ['八步区', '平桂区', '昭平县', '钟山县', '富川瑶族自治县'],
        '河池市': ['金城江区', '宜州区', '南丹县', '天峨县', '凤山县', '东兰县', '罗城仫佬族自治县', '环江毛南族自治县', '巴马瑶族自治县', '都安瑶族自治县', '大化瑶族自治县'],
        '来宾市': ['兴宾区', '忻城县', '象州县', '武宣县', '金秀瑶族自治县', '合山市'],
        '崇左市': ['江州区', '扶绥县', '宁明县', '龙州县', '大新县', '天等县', '凭祥市'],
        '广州市': ['荔湾区', '越秀区', '海珠区', '天河区', '白云区', '黄埔区', '番禺区', '花都区', '南沙区', '从化区', '增城区'],
        '深圳市': ['罗湖区', '福田区', '南山区', '宝安区', '龙岗区', '盐田区', '龙华区', '坪山区', '光明区'],
        '珠海市': ['香洲区', '斗门区', '金湾区'],
        '东莞市': ['东城街道', '南城街道', '万江街道', '莞城街道', '石碣镇', '石龙镇', '茶山镇', '石排镇', '企石镇', '横沥镇', '桥头镇', '谢岗镇', '东坑镇', '常平镇', '寮步镇', '大朗镇', '黄江镇', '清溪镇', '塘厦镇', '凤岗镇', '大岭山镇', '长安镇', '虎门镇', '厚街镇', '沙田镇', '道滘镇', '洪梅镇', '麻涌镇', '望牛墩镇', '中堂镇', '高埗镇'],
        '北京市': ['东城区', '西城区', '朝阳区', '丰台区', '石景山区', '海淀区', '门头沟区', '房山区', '通州区', '顺义区', '昌平区', '大兴区', '怀柔区', '平谷区', '密云区', '延庆区'],
        '上海市': ['黄浦区', '徐汇区', '长宁区', '静安区', '普陀区', '虹口区', '杨浦区', '闵行区', '宝山区', '嘉定区', '浦东新区', '金山区', '松江区', '青浦区', '奉贤区', '崇明区'],
        '杭州市': ['上城区', '拱墅区', '西湖区', '滨江区', '萧山区', '余杭区', '富阳区', '临安区', '临平区', '钱塘区', '桐庐县', '淳安县', '建德市'],
        '成都市': ['锦江区', '青羊区', '金牛区', '武侯区', '成华区', '龙泉驿区', '青白江区', '新都区', '温江区', '双流区', '郫都区', '新津区', '金堂县', '大邑县', '蒲江县', '都江堰市', '彭州市', '邛崃市', '崇州市', '简阳市'],
        '武汉市': ['江岸区', '江汉区', '硚口区', '汉阳区', '武昌区', '青山区', '洪山区', '东西湖区', '汉南区', '蔡甸区', '江夏区', '黄陂区', '新洲区'],
        '南京市': ['玄武区', '秦淮区', '建邺区', '鼓楼区', '浦口区', '栖霞区', '雨花台区', '江宁区', '六合区', '溧水区', '高淳区'],
        '重庆市': ['万州区', '涪陵区', '渝中区', '大渡口区', '江北区', '沙坪坝区', '九龙坡区', '南岸区', '北碚区', '綦江区', '大足区', '渝北区', '巴南区', '黔江区', '长寿区', '江津区', '合川区', '永川区', '南川区', '璧山区', '铜梁区', '潼南区', '荣昌区', '开州区', '梁平区', '武隆区']
      },
      // 省份列表
      provinceOptions: [
        { label: '北京市', value: '北京市' }, { label: '天津市', value: '天津市' },
        { label: '河北省', value: '河北省' }, { label: '山西省', value: '山西省' },
        { label: '内蒙古自治区', value: '内蒙古自治区' }, { label: '辽宁省', value: '辽宁省' },
        { label: '吉林省', value: '吉林省' }, { label: '黑龙江省', value: '黑龙江省' },
        { label: '上海市', value: '上海市' }, { label: '江苏省', value: '江苏省' },
        { label: '浙江省', value: '浙江省' }, { label: '安徽省', value: '安徽省' },
        { label: '福建省', value: '福建省' }, { label: '江西省', value: '江西省' },
        { label: '山东省', value: '山东省' }, { label: '河南省', value: '河南省' },
        { label: '湖北省', value: '湖北省' }, { label: '湖南省', value: '湖南省' },
        { label: '广东省', value: '广东省' }, { label: '广西壮族自治区', value: '广西壮族自治区' },
        { label: '海南省', value: '海南省' }, { label: '重庆市', value: '重庆市' },
        { label: '四川省', value: '四川省' }, { label: '贵州省', value: '贵州省' },
        { label: '云南省', value: '云南省' }, { label: '西藏自治区', value: '西藏自治区' },
        { label: '陕西省', value: '陕西省' }, { label: '甘肃省', value: '甘肃省' },
        { label: '青海省', value: '青海省' }, { label: '宁夏回族自治区', value: '宁夏回族自治区' },
        { label: '新疆维吾尔自治区', value: '新疆维吾尔自治区' }
      ],
      // 城市映射表
      cityMap: {
        '北京市': ['北京市'],
        '天津市': ['天津市'],
        '上海市': ['上海市'],
        '重庆市': ['重庆市'],
        '河北省': ['石家庄市', '唐山市', '秦皇岛市', '邯郸市', '邢台市', '保定市', '张家口市', '承德市', '沧州市', '廊坊市', '衡水市'],
        '山西省': ['太原市', '大同市', '阳泉市', '长治市', '晋城市', '朔州市', '晋中市', '运城市', '忻州市', '临汾市', '吕梁市'],
        '内蒙古自治区': ['呼和浩特市', '包头市', '乌海市', '赤峰市', '通辽市', '鄂尔多斯市', '呼伦贝尔市', '巴彦淖尔市', '乌兰察布市', '兴安盟', '锡林郭勒盟', '阿拉善盟'],
        '辽宁省': ['沈阳市', '大连市', '鞍山市', '抚顺市', '本溪市', '丹东市', '锦州市', '营口市', '阜新市', '辽阳市', '盘锦市', '铁岭市', '朝阳市', '葫芦岛市'],
        '吉林省': ['长春市', '吉林市', '四平市', '辽源市', '通化市', '白山市', '松原市', '白城市', '延边朝鲜族自治州'],
        '黑龙江省': ['哈尔滨市', '齐齐哈尔市', '鸡西市', '鹤岗市', '双鸭山市', '大庆市', '伊春市', '佳木斯市', '七台河市', '牡丹江市', '黑河市', '绥化市', '大兴安岭地区'],
        '江苏省': ['南京市', '无锡市', '徐州市', '常州市', '苏州市', '南通市', '连云港市', '淮安市', '盐城市', '扬州市', '镇江市', '泰州市', '宿迁市'],
        '浙江省': ['杭州市', '宁波市', '温州市', '嘉兴市', '湖州市', '绍兴市', '金华市', '衢州市', '舟山市', '台州市', '丽水市'],
        '安徽省': ['合肥市', '芜湖市', '蚌埠市', '淮南市', '马鞍山市', '淮北市', '铜陵市', '安庆市', '黄山市', '滁州市', '阜阳市', '宿州市', '六安市', '亳州市', '池州市', '宣城市'],
        '福建省': ['福州市', '厦门市', '莆田市', '三明市', '泉州市', '漳州市', '南平市', '龙岩市', '宁德市'],
        '江西省': ['南昌市', '景德镇市', '萍乡市', '九江市', '新余市', '鹰潭市', '赣州市', '吉安市', '宜春市', '抚州市', '上饶市'],
        '山东省': ['济南市', '青岛市', '淄博市', '枣庄市', '东营市', '烟台市', '潍坊市', '济宁市', '泰安市', '威海市', '日照市', '临沂市', '德州市', '聊城市', '滨州市', '菏泽市'],
        '河南省': ['郑州市', '开封市', '洛阳市', '平顶山市', '安阳市', '鹤壁市', '新乡市', '焦作市', '濮阳市', '许昌市', '漯河市', '三门峡市', '南阳市', '商丘市', '信阳市', '周口市', '驻马店市', '济源市'],
        '湖北省': ['武汉市', '黄石市', '十堰市', '宜昌市', '襄阳市', '鄂州市', '荆门市', '孝感市', '荆州市', '黄冈市', '咸宁市', '随州市', '恩施土家族苗族自治州', '仙桃市', '潜江市', '天门市', '神农架林区'],
        '湖南省': ['长沙市', '株洲市', '湘潭市', '衡阳市', '邵阳市', '岳阳市', '常德市', '张家界市', '益阳市', '郴州市', '永州市', '怀化市', '娄底市', '湘西土家族苗族自治州'],
        '广东省': ['广州市', '深圳市', '珠海市', '汕头市', '佛山市', '韶关市', '湛江市', '肇庆市', '江门市', '茂名市', '惠州市', '梅州市', '汕尾市', '河源市', '阳江市', '清远市', '东莞市', '中山市', '潮州市', '揭阳市', '云浮市'],
        '广西壮族自治区': ['南宁市', '柳州市', '桂林市', '梧州市', '北海市', '防城港市', '钦州市', '贵港市', '玉林市', '百色市', '贺州市', '河池市', '来宾市', '崇左市'],
        '海南省': ['海口市', '三亚市', '三沙市', '儋州市'],
        '四川省': ['成都市', '自贡市', '攀枝花市', '泸州市', '德阳市', '绵阳市', '广元市', '遂宁市', '内江市', '乐山市', '南充市', '眉山市', '宜宾市', '广安市', '达州市', '雅安市', '巴中市', '资阳市', '阿坝藏族羌族自治州', '甘孜藏族自治州', '凉山彝族自治州'],
        '贵州省': ['贵阳市', '六盘水市', '遵义市', '安顺市', '毕节市', '铜仁市', '黔西南布依族苗族自治州', '黔东南苗族侗族自治州', '黔南布依族苗族自治州'],
        '云南省': ['昆明市', '曲靖市', '玉溪市', '保山市', '昭通市', '丽江市', '普洱市', '临沧市', '楚雄彝族自治州', '红河哈尼族彝族自治州', '文山壮族苗族自治州', '西双版纳傣族自治州', '大理白族自治州', '德宏傣族景颇族自治州', '怒江傈僳族自治州', '迪庆藏族自治州'],
        '西藏自治区': ['拉萨市', '日喀则市', '昌都市', '林芝市', '山南市', '那曲市', '阿里地区'],
        '陕西省': ['西安市', '铜川市', '宝鸡市', '咸阳市', '渭南市', '延安市', '汉中市', '榆林市', '安康市', '商洛市'],
        '甘肃省': ['兰州市', '嘉峪关市', '金昌市', '白银市', '天水市', '武威市', '张掖市', '平凉市', '酒泉市', '庆阳市', '定西市', '陇南市', '临夏回族自治州', '甘南藏族自治州'],
        '青海省': ['西宁市', '海东市', '海北藏族自治州', '黄南藏族自治州', '海南藏族自治州', '果洛藏族自治州', '玉树藏族自治州', '海西蒙古族藏族自治州'],
        '宁夏回族自治区': ['银川市', '石嘴山市', '吴忠市', '固原市', '中卫市'],
        '新疆维吾尔自治区': ['乌鲁木齐市', '克拉玛依市', '吐鲁番市', '哈密市', '昌吉回族自治州', '博尔塔拉蒙古自治州', '巴音郭楞蒙古自治州', '阿克苏地区', '克孜勒苏柯尔克孜自治州', '喀什地区', '和田地区', '伊犁哈萨克自治州', '塔城地区', '阿勒泰地区']
      },
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      btnX: 0,
      btnY: 0,
      hasMoved: false
    }
  },
  watch: {
    showCheckout (val) {
      if (val) {
        this.loadUserAddress()
        this.fetchAvailableCoupons()
      }
    },
    // 购物车变化（加载/删除/清空/下单后）同步到全局 store，让 CartFloatEntry 角标即时更新
    cartItems (val) {
      this.$store.commit('setCartCount', (val || []).length)
    },
    // 地址文字手改 → 清地址簿坐标（_picking 区分 onPickAddress 回填；保证提交坐标与显示地址一致）
    fullAddress () {
      if (this._picking) return
      if (this.selectedAddressLat != null || this.selectedAddressLng != null) {
        this.selectedAddressLat = null
        this.selectedAddressLng = null
      }
    }
  },
  beforeDestroy () {
  },
  computed: {
    // 自提地址（履约配置）：选择自提时展示实际取货地点；未配置明示，不显示错误地址
    pickupAddress () {
      return (this.publicCfg && this.publicCfg.pickupAddress) || ''
    },
    // 完整收货地址：省+市+区+详细地址自动派生。
    // 校验和提交都用它，省市区/详细地址任一变化都自动重算，无需手动同步（旧 updateFullAddress 已删）。
    fullAddress () {
      const detail = this.contactInfo.detail || ''
      return `${this.selectedProvince}${this.selectedCity}${this.selectedDistrict}${detail}`
    },
    // 城市选项 - 根据选择的省份动态变化
    cityOptions () {
      if (!this.selectedProvince || !this.cityMap[this.selectedProvince]) {
        return []
      }
      return this.cityMap[this.selectedProvince].map(city => ({
        label: city,
        value: city
      }))
    },
    // 区选项 - 根据选择的城市动态变化
    districtOptions () {
      if (!this.selectedCity || !this.districtMap[this.selectedCity]) {
        return []
      }
      return this.districtMap[this.selectedCity].map(district => ({
        label: district,
        value: district
      }))
    },
    totalQuantity () {
      return this.cartItems.reduce((sum, item) => sum + item.quantity, 0)
    },
    selectedQuantity () {
      return this.cartItems
        .filter(item => this.selectedItems.includes(item.id))
        .reduce((sum, item) => sum + item.quantity, 0)
    },
    selectedCoupon () {
      return this.couponList.find(c => c.user_coupon_id === this.selectedCouponId) || null
    },
    selectAll: {
      get () {
        return this.cartItems.length > 0 && this.selectedItems.length === this.cartItems.length
      },
      set (val) {
        if (val) {
          this.selectedItems = this.cartItems.map(item => item.id)
        } else {
          this.selectedItems = []
        }
      }
    }
  },
  created () {
    // 自提地址当前值：选择自提时展示取货地点（下单即冻结为订单快照）
    fetchPublicConfig().then(cfg => { this.publicCfg = cfg }).catch(() => {})
    this.fetchCart()
    this.handleQueryParams()
  },
  methods: {
    // 处理URL查询参数（用于详情页直达结算）
    handleQueryParams () {
      const { checkout, select } = this.$route.query
      if (checkout === '1' && select) {
        // 等待购物车加载完成
        this.$nextTick(() => {
          // 自动选中指定商品
          const cartId = parseInt(select)
          if (this.cartItems.some(item => item.id === cartId)) {
            this.selectedItems = [cartId]
            // 自动打开结算弹窗
            this.showCheckout = true
          }
        })
      }
    },
    // 省份选择变化时触发
    onProvinceChange (province) {
      // 当省份改变时，重置城市选择
      const cities = this.cityMap[province] || []
      if (cities.length > 0 && !cities.includes(this.selectedCity)) {
        this.selectedCity = cities[0]
      }
      // 重置区选择
      this.selectedDistrict = ''
    },
    // 城市选择变化时触发
    onCityChange (city) {
      // 当城市改变时，重置区选择
      this.selectedDistrict = ''
      // 如果该城市有区数据，自动选择第一个
      if (this.districtMap[city] && this.districtMap[city].length > 0) {
        this.selectedDistrict = this.districtMap[city][0]
      }
    },
    // 选中已保存地址后回填到内联表单（既作展示也允许微调），并记录 id+坐标 供下单优先使用
    onPickAddress (addr) {
      this._picking = true
      this.contactInfo.name = addr.receiver_name || ''
      this.contactInfo.phone = addr.receiver_phone || ''
      this.contactInfo.detail = addr.address || ''
      this.selectedProvince = addr.province || this.selectedProvince
      this.selectedCity = addr.city || this.selectedCity
      this.$nextTick(() => { this.selectedDistrict = addr.district || this.selectedDistrict })
      this.selectedAddressId = addr.id
      this.selectedAddressLat = addr.latitude != null && addr.latitude !== '' ? Number(addr.latitude) : null
      this.selectedAddressLng = addr.longitude != null && addr.longitude !== '' ? Number(addr.longitude) : null
      this.$nextTick(() => { this.$nextTick(() => { this._picking = false }) })
    },
    goToOrders () {
      setTimeout(() => {
        this.$router.push('/order')
        // 以防万一，手动清理 Quasar 添加的类
        document.body.classList.remove('q-body--prevent-scroll')
      }, 300)
    },
    toBack () {
      // 如果有历史记录则返回，否则跳转到首页
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/home')
      }
    },
    onBackClick () {
      this.toBack()
    },
    // 处理直接输入的数量改变
    async handleQuantityInput (item) {
      let val = item.display_quantity
      if (typeof val !== 'number' || isNaN(val)) {
        val = 1
      }
      val = Math.floor(val)
      if (val < 1) val = 1

      const ratio = Number(item.unit_ratio) > 1 ? Number(item.unit_ratio) : 1
      const maxDisplay = ratio > 1 ? Math.floor(item.stock / ratio) : item.stock

      if (val > maxDisplay) val = maxDisplay

      item.display_quantity = val

      const newActualQty = val * ratio

      try {
        const token = localStorage.getItem('token')
        const res = await this.axios({
          url: `${apiConfig.apiList.updateCart}/${item.id}`,
          method: 'put',
          headers: { Authorization: `Bearer ${token}` },
          data: {
            quantity: newActualQty,
            display_quantity: val
          }
        })
        if (res.data.code === 200) {
          item.quantity = newActualQty
        } else {
          // 回退到接口保存的旧数据（可选，这里简单处理）
        }
      } catch (err) {
        console.error('更新数量失败:', err)
        Notify.create({
          message: '更新失败',
          color: 'negative',
          position: 'top'
        })
      }
    },
    loadUserAddress () {
      // 先从专门的收货地址接口获取
      this.axios.get('/user/address').then(res => {
        if (res.data.code === 200 && res.data.data) {
          const hasAddressData = res.data.data.receiver_name || res.data.data.receiver_phone || res.data.data.address
          if (hasAddressData) {
            this.fillUserAddress(res.data.data)
            return
          }
        }
        // 没有保存的地址，从用户资料获取姓名和电话
        this.loadAddressFromUserProfile()
      }).catch(err => {
        console.error('获取收货地址失败:', err)
        // 接口失败时尝试从用户资料获取
        this.loadAddressFromUserProfile()
      })
    },
    // 从用户资料加载地址信息（作为fallback）
    loadAddressFromUserProfile () {
      this.axios.get(apiConfig.apiList.getUserInfo).then(res => {
        if (res.data.code === 200 && res.data.data) {
          const user = res.data.data
          // 只填充姓名和电话，让用户自己填地址
          this.contactInfo.name = user.nickname || user.name || ''
          this.contactInfo.phone = user.phone || ''
        }
      }).catch(err => {
        console.error('获取用户资料失败:', err)
      })
    },
    fillUserAddress (user) {
      // 自动填充收货地址信息
      this.contactInfo.name = user.receiver_name || ''
      this.contactInfo.phone = user.receiver_phone || ''
      // 设置省份、城市和区县选择器
      const province = user.province || '广西壮族自治区'
      const city = user.city || '贺州市'
      const district = user.district || '八步区'

      if (this.provinceOptions.some(p => p.value === province)) {
        this.selectedProvince = province
      }
      if (this.cityOptions.some(c => c.value === city)) {
        this.selectedCity = city
      }
      // 等待城市设置后再设置区县
      this.$nextTick(() => {
        if (this.districtOptions.some(d => d.value === district)) {
          this.selectedDistrict = district
        }
      })
      // 处理已保存的地址
      if (user.address) {
        this.contactInfo.detail = user.address
      }
      // 快照当前加载的地址（用于下单时判断是否被用户修改过）
      this.loadedAddressSnapshot = {
        name: this.contactInfo.name,
        phone: this.contactInfo.phone,
        province: this.selectedProvince,
        city: this.selectedCity,
        district: this.selectedDistrict,
        detail: this.contactInfo.detail
      }
    },
    // 保存收货地址：仅在用户主动修改了地址后才创建新地址（默认地址未改不重复插入）
    async saveUserAddress () {
      // 1) 已选保存过的地址 → 跳过
      if (this.selectedAddressId) return
      // 2) 默认地址未修改 → 跳过（对比快照）
      if (this.loadedAddressSnapshot) {
        const s = this.loadedAddressSnapshot
        if (s.name === this.contactInfo.name &&
            s.phone === this.contactInfo.phone &&
            s.province === this.selectedProvince &&
            s.city === this.selectedCity &&
            s.district === this.selectedDistrict &&
            s.detail === this.contactInfo.detail) {
          return // 地址未修改，不创建新地址
        }
      }
      try {
        await this.axios.post(apiConfig.apiList.addressList, {
          receiver_name: this.contactInfo.name,
          receiver_phone: this.contactInfo.phone,
          province: this.selectedProvince,
          city: this.selectedCity,
          district: this.selectedDistrict,
          address: this.contactInfo.detail,
          is_default: true
        })
      } catch (err) {
        console.error('保存收货地址失败:', err)
      }
    },
    async fetchCart () {
      this.loading = true
      try {
        const token = localStorage.getItem('token')
        if (!token) {
          this.$router.push('/')
          return
        }

        const res = await this.axios({
          url: apiConfig.apiList.getCart,
          method: 'get',
          headers: { Authorization: `Bearer ${token}` }
        })

        if (res.data.code === 200) {
          this.cartItems = res.data.data
          // 进入货篮默认全选
          this.selectedItems = this.cartItems.map(item => item.id)
        }
      } catch (err) {
        console.error('获取货篮失败:', err)
        Notify.create({
          message: '获取货篮失败',
          color: 'negative',
          position: 'top'
        })
      } finally {
        this.loading = false
      }
    },
    categoryText (category) {
      return getCategoryName(category)
    },
    toggleSelect (itemId) {
      const index = this.selectedItems.indexOf(itemId)
      if (index > -1) {
        this.selectedItems.splice(index, 1)
      } else {
        this.selectedItems.push(itemId)
      }
    },
    async updateQuantity (item, delta) {
      // 根据单位类型计算新的显示数量
      const currentDisplay = item.display_quantity || item.quantity
      const newDisplayQty = currentDisplay + delta

      // ratio 快照（基础单位=1 → 显示数即基础数，单一公式无分支）
      const ratio = Number(item.unit_ratio) > 1 ? Number(item.unit_ratio) : 1
      const maxDisplay = ratio > 1 ? Math.floor(item.stock / ratio) : item.stock

      if (newDisplayQty < 1 || newDisplayQty > maxDisplay) return

      const newActualQty = newDisplayQty * ratio

      try {
        const token = localStorage.getItem('token')
        const res = await this.axios({
          url: `${apiConfig.apiList.updateCart}/${item.id}`,
          method: 'put',
          headers: { Authorization: `Bearer ${token}` },
          data: {
            quantity: newActualQty,
            display_quantity: newDisplayQty
          }
        })

        if (res.data.code === 200) {
          item.quantity = newActualQty
          item.display_quantity = newDisplayQty
        }
      } catch (err) {
        console.error('更新数量失败:', err)
        Notify.create({
          message: '更新失败',
          color: 'negative',
          position: 'top'
        })
      }
    },
    clickDelete (item) {
      const slideRef = this.$refs['slideItem_' + item.id]
      const slideItem = slideRef && slideRef[0] ? slideRef[0] : null
      const resetFn = slideItem ? slideItem.reset : () => {}
      this.promptDelete(item, resetFn)
    },
    promptDelete (item, resetFn) {
      console.log('Swipe/Click triggered for item:', item)
      Dialog.create({
        title: '确认移除',
        message: '确定要从货篮中移除此商品吗？',
        cancel: true,
        persistent: true
      }).onOk(async () => {
        try {
          const token = localStorage.getItem('token')
          const res = await this.axios({
            url: `${apiConfig.apiList.deleteCart}/${item.id}`,
            method: 'delete',
            headers: { Authorization: `Bearer ${token}` }
          })

          if (res.data.code === 200) {
            Notify.create({
              message: '已移除商品',
              color: 'positive',
              position: 'top',
              timeout: 1000
            })
            // 先复位DOM动画防止残留
            if (resetFn) resetFn()

            // 从列表中移除
            const index = this.cartItems.findIndex(cartItem => cartItem.id === item.id)
            if (index > -1) {
              this.cartItems.splice(index, 1)
            }
            // 从选中列表中安全移除
            if (this.selectedItems.includes(item.id)) {
              this.selectedItems = this.selectedItems.filter(id => id !== item.id)
            }
          } else {
            console.error('移除失败:', res.data.message)
            if (resetFn) resetFn()
          }
        } catch (err) {
          console.error('移除失败:', err)
          Notify.create({
            message: '移除失败',
            color: 'negative',
            position: 'top'
          })
          if (resetFn) resetFn()
        }
      }).onCancel(() => {
        // 如果取消，滑动回原位
        if (resetFn) resetFn()
      })
    },
    async openCouponPicker () {
      // 拉取全部未用券（含门槛标签）；金额门槛由服务端下单时权威校验，前端不算金额
      await this.fetchAvailableCoupons()
      this.showCouponPicker = true
    },
    async fetchAvailableCoupons () {
      try {
        const res = await this.axios.get(apiConfig.apiList.availableCoupons)
        if (res.data.code === 200) {
          this.couponList = res.data.data || []
          if (this.selectedCouponId && !this.couponList.find(c => c.user_coupon_id === this.selectedCouponId)) {
            this.selectedCouponId = null
          }
        }
      } catch (e) { /* ignore */ }
    },
    pickCoupon (c) {
      this.selectedCouponId = c ? c.user_coupon_id : null
      this.showCouponPicker = false
    },
    async submitOrder () {
      if (this.selectedItems.length === 0) return

      // 验证收货信息
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!this.contactInfo.name || !this.contactInfo.name.trim()) {
        Notify.create({ message: '请填写收货人姓名', color: 'negative', position: 'top' })
        return
      }
      if (!this.contactInfo.phone || !phoneRegex.test(this.contactInfo.phone)) {
        Notify.create({ message: '请填写正确的手机号码', color: 'negative', position: 'top' })
        return
      }
      // 自提到店取货，无需收货地址
      if (this.fulfillmentMode !== 'pickup' && (!this.fullAddress || !this.fullAddress.trim())) {
        Notify.create({ message: '请填写收货地址', color: 'negative', position: 'top' })
        return
      }

      this.submitting = true
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios({
          url: apiConfig.apiList.createOrder,
          method: 'post',
          headers: { Authorization: `Bearer ${token}` },
          data: {
            from_cart: true,
            cart_ids: this.selectedItems,
            address_id: this.fulfillmentMode === 'pickup' ? undefined : this.selectedAddressId,
            contact_name: this.contactInfo.name,
            contact_phone: this.contactInfo.phone,
            contact_address: this.fulfillmentMode === 'pickup' ? '' : this.fullAddress,
            latitude: this.fulfillmentMode === 'pickup' ? undefined : this.selectedAddressLat,
            longitude: this.fulfillmentMode === 'pickup' ? undefined : this.selectedAddressLng,
            accept_substitute: this.acceptSubstitute,
            user_coupon_id: this.selectedCouponId || undefined,
            fulfillment_mode: this.fulfillmentMode
          }
        })

        if (res.data.code === 200) {
          // 保存收货地址，下次下单自动回填（不阻塞下单成功提示）
          this.saveUserAddress()
          this.showCheckout = false
          this.showSuccess = true
          // 清空已选中的商品
          this.cartItems = this.cartItems.filter(item => !this.selectedItems.includes(item.id))
          this.selectedItems = []
          this.selectedCouponId = null
        } else {
          Notify.create({
            message: res.data.message || '下单失败',
            color: 'negative',
            position: 'top'
          })
        }
      } catch (err) {
        console.error('下单失败:', err)
        Notify.create({
          message: '下单失败，请稍后重试',
          color: 'negative',
          position: 'top'
        })
      } finally {
        this.submitting = false
      }
    }
  }
}
